/* eslint-disable */
import ImporterViewer from './importerviewer.js'
import JSM from './jsmodeler.js'
/* eslint-disable */
var ExtensionInterface = function (app) {
  this.app = app
}
ExtensionInterface.prototype.GetModelJson = function () {
  return this.app.viewer.GetJsonData()
}
var ImporterApp = function () {
  this.viewer = null
  this.fileNames = null
  this.inGenerate = false
  this.importerButtons= null
  this.extensions = []
  this.readyForTest = null
  this.loading = {
    webGl: false
  }
}
ImporterApp.prototype.Init = function (files) {
  window.addEventListener('resize', this.Resize.bind(this), false)
  this.Resize()
  this.loading.webGl = true
  this.viewer = new ImporterViewer()
  this.viewer.Init('example')
  window.onhashchange = this.LoadFilesFromHash.bind(this)
  if(files){
    this.ProcessFiles(files,0)
  }
}
ImporterApp.prototype.ZoomIn = function () {
  this.viewer.viewer.navigation.Zoom(0.2)
  this.viewer.viewer.navigation.DrawCallback()

}
ImporterApp.prototype.ZoomOut = function () {
  this.viewer.viewer.navigation.Zoom(-0.3)
  this.viewer.viewer.navigation.DrawCallback()

}

ImporterApp.prototype.againDraw = function () {
  this.viewer.viewer.navigation.DrawCallback()
}
ImporterApp.prototype.JsonLoaded = function () {
  var jsonData = this.viewer.GetJsonData()
  this.meshVisibility = {}
  var i;
  for (i = 0; i < jsonData.meshes.length; i++) {
    this.meshVisibility[i] = true
  }
  this.Generate()
};
ImporterApp.prototype.Generate = function () {
  function ShowMeshes(importerApp, merge) {
    var environment = {
      onStart: function (taskCount) {
        console.log(taskCount, '初始化')
      },
      onProgress: function (currentTask) {
        console.log(currentTask)
      },
      onFinish: function () {
        importerApp.loading.webGl = false
        console.log("完成")
        importerApp.inGenerate = false
      }
    }

    if (merge) {
      var jsonData = importerApp.viewer.GetJsonData()
      importerApp.viewer.SetJsonData(JSM.MergeJsonDataMeshes(jsonData))
    }
    importerApp.viewer.ShowAllMeshes(environment)
  }
  var myThis = this
  ShowMeshes(myThis, false)
}
ImporterApp.prototype.Resize = function () {
  function SetWidth(elem, value) {
    elem.width = value
    elem.style.width = value + 'px'
  }
  function SetHeight(elem, value) {
    elem.height = value
    elem.style.height = value + 'px'
  }
  var canvas = document.getElementById('example')
  var height = document.getElementById('gem-detail').offsetHeight
  SetHeight(canvas, height)
  SetWidth(canvas, document.getElementById('gem-detail').offsetWidth)
}
ImporterApp.prototype.ProcessFiles = function (fileList, isUrl) {
  var userFiles = fileList
  if (userFiles.length === 0) {
    return
  }

  this.fileNames = null
  var myThis = this
  var processorFunc = JSM.ConvertFileListToJsonData
  if (isUrl) {
    processorFunc = JSM.ConvertURLListToJsonData
  }

  processorFunc(userFiles, {
    onReady: function (fileNames, jsonData) {
      myThis.fileNames = fileNames
      myThis.viewer.SetJsonData(jsonData)
      myThis.JsonLoaded()
    }
  })
}
ImporterApp.prototype.LoadFilesFromHash = function (fileList) {
  this.ProcessFiles(fileList, false)
  return true
}
ImporterApp.prototype.show = function (files) {
  this.ProcessFiles(files,0)
}



export default ImporterApp
